module.exports = __webpack_public_path__ + "static/media/readmore.4d560103.jpg";